import { Variants } from 'framer-motion';

/**
 * Shared constants for Hero components across the application
 */

// Grain texture overlay style - creates subtle film/noise texture
export const HERO_GRAIN_STYLE = {
  backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
  opacity: 0.08,
};

// Gradient overlay for text contrast
export const HERO_GRADIENT =
  'linear-gradient(to bottom, var(--color-overlay-30) 0%, var(--color-overlay-10) 30%, var(--color-overlay-50) 70%, var(--color-overlay-85) 100%)';

// Hero section dimensions
export const HERO_DIMENSIONS = {
  height: { base: '380px', md: '420px' },
  imageBottom: -80,
  padding: { base: 4, md: 6 },
};

// Parallax scroll transform ranges
export const HERO_SCROLL_RANGES = {
  parallax: { input: [0, 300], output: [0, 80] },
  scale: { input: [0, 300], output: [1, 1.15] },
  opacity: { input: [0, 250], output: [1, 0.3] },
  contentY: { input: [0, 200], output: [0, -30] },
};

// Animation variants for staggered entrance of stat badges
export const heroStatsContainerVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      staggerChildren: 0.1,
    },
  },
};

export const heroStatItemVariants: Variants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.3 },
  },
};

// Back button styling — standard card-token treatment (D45a Phase 6 glass
// conversion; this was one of the 27 non-roster glass surfaces, per
// docs/current_work/prototypes/d45a_phase5_triage.md §2).
export const HERO_BACK_BUTTON_STYLES = {
  bg: 'var(--card-bg)',
  hoverBg: 'var(--card-surface-2)',
  backdropFilter: 'none',
  borderRadius: 'full',
};

// Stat badge styling — standard card-token treatment (D45a Phase 6 glass
// conversion; see note above).
export const HERO_STAT_BADGE_STYLES = {
  bg: 'var(--card-bg)',
  hoverBg: 'var(--card-surface-2)',
  backdropFilter: 'none',
  borderRadius: 'var(--r-card-compact)',
  border: 'var(--card-border)',
};
